// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u2oXm","colBig":"styles_colBig__1wTSO","colSmall":"styles_colSmall__2jcdj"};